export const CUSTOMER_ID_KEY = 'customerId';
export const INTERNAL_CUSTOMER_ID_KEY = 'internalCustomerId';
export const INTEGRATION_ID_KEY = 'integrationId';
export const PRODUCT_NAME_KEY = 'ProductName';
export const PRODUCT_VARIANT_TITLE = 'ProductVariantTite';
export const VOICEFLOW_PARAM = 'voiceflow';
export const BU_UNIT_KEY = 'buUnit';
export const SIGNER_DETAILS = 'signerDetails';
export const WATCHED_VIDEOS = 'watchedVideos';
